import {VisImpFontSize, VisImpFontType, VisImpLetterSpacing} from '../models/visuallyImpairedSettings';

export const fontSizes = [
  {
    title: 'A',
    value: VisImpFontSize.Small,
    styles: {
      text: {
        fontSize: 19,
        lineHeight: 22,
      },
      container: {
        height: 30,
        width: 30,
      },
    },
  },
  {
    title: 'A',
    value: VisImpFontSize.Medium,
    styles: {
      text: {
        fontSize: 24,
        lineHeight: 28,
      },
      container: {
        height: 30,
        width: 30,
      },
    },
  },
  {
    title: 'A',
    value: VisImpFontSize.Large,
    styles: {
      text: {
        fontSize: 29,
        lineHeight: 33,
        fontWeight: '700',
      },
      container: {
        height: 30,
        width: 30,
      },
    },
  },
];

export const intervals = [
  {
    title: 'Нормальный',
    value: VisImpLetterSpacing.Normal,
  },
  {
    title: 'Увеличенный',
    value: VisImpLetterSpacing.Increased,
  },
  {
    title: 'Большой',
    value: VisImpLetterSpacing.Big,
  },
];

export const fontTypes = [
  {
    title: 'Без засечек',
    value: VisImpFontType.SansSerif,
  },
  {
    title: 'С засечками',
    value: VisImpFontType.Serif,
  },
];
